module.exports = __webpack_public_path__ + "static/assets/70714c4c813030ab61467e02503d8306.png";